<div class="cashflow-table-wrapper relative">
  <app-dynamic-projected-table
    emptyTableMessage="There is no data corresponding to the filters."
    [isEmpty]="sortedCashflowData()?.items.length <= 0"
    [isLoading]="isLoading()"
    [useHorizontalScrollbar]="false"
  >
    <div tableHeader class="grid-table header">
      <div class="grid-row">
        <div class="item pl-5 flex justify-between items-center">
          <div class="flex items-center">
            <div class="cursor-pointer" (click)="sortBy(SORT.name)">
              {{ isViewProject() ? 'Budget Lines' : 'Projects' }}
            </div>
            <app-sort-arrow
              class="ml-1 mt-0.5"
              [hide]="sorting().field !== SORT.name"
              [isDesc]="sorting().direction < 0"
            ></app-sort-arrow>
          </div>
          <div class="flex items-center gap-2.5">
            <app-checkbox
              [(ngModel)]="showZeroDollarLineItems"
              (onChange)="onZeroDollarChange($event)"
              [appTooltip]="showZeroDollarLineItems ? 'Hide zero dollar lines' : 'Show zero dollar lines'"
              tooltipPosition="right"
              class="ml-6"
            ></app-checkbox>
            <span
              [appTooltip]="tooltipText()"
              tooltipPosition="bottom"
              class="icon icon-info-filled text-size_3xl text-navy-700"
            ></span>
          </div>
        </div>
        <div class="item">
          <span>Year</span>
        </div>
        @for (month of months(); track $index) {
          <div class="item month">
            {{ month }}
          </div>
        }
      </div>
    </div>
    <div projectedTable class="grid-table content">
      @for (item of sortedCashflowData()?.items; track item.id; let lineIndex = $index) {
        @if (item?.expenses) {
          <div class="grid-row">
            <div
              class="item pl-5"
              [ngClass]="{
                'cursor-default': isViewProject(),
                'cursor-pointer': !isViewProject(),
              }"
              (click)="!isViewProject() && openViewProject(item.id)"
            >
              <app-faded-text>
                {{ item.name }}
              </app-faded-text>
            </div>
            <div
              [tooltipStyleClass]="item.yearTotal < 0 ? 'negative' : ''"
              [appTooltip]="item.yearTotal | money: 'positiveComa'"
              tooltipPosition="bottom"
              [ngClass]="{ negative: item.yearTotal < 0 }"
              class="item"
            >
              {{ item.yearTotal | money: 'shortSignSimpleSpace' }}
            </div>
            @for (expense of item.expenses; track $index) {
              <div class="item cashflow-value" [ngClass]="{ negative: expense < 0 }">
                <span
                  [tooltipStyleClass]="expense < 0 ? 'negative' : ''"
                  [appTooltip]="expense | money: 'positiveComa'"
                  tooltipPosition="bottom"
                >
                  {{ expense | money: 'shortSignSimpleSpace' }}
                </span>
              </div>
            }
          </div>
        }
      }
    </div>

    <div tableFooter>
      <div class="grid-table totals">
        <div class="grid-row">
          <div class="item">Total Expense</div>
          <div
            class="item"
            [tooltipStyleClass]="sortedCashflowData()?.total.yearTotal < 0 ? 'negative' : ''"
            [appTooltip]="sortedCashflowData()?.total.yearTotal | money: 'positiveComa'"
            [ngClass]="{ negative: sortedCashflowData()?.total.yearTotal < 0 }"
            tooltipPosition="top"
          >
            {{ sortedCashflowData()?.total.yearTotal | money: 'shortSignSimpleSpace' }}
          </div>
          @for (expense of sortedCashflowData()?.total.expenses; track $index) {
            <div [ngClass]="{ negative: expense < 0 }" class="item totals-value">
              <span
                [tooltipStyleClass]="expense < 0 ? 'negative' : ''"
                [appTooltip]="expense | money: 'positiveComa'"
                tooltipPosition="top"
              >
                {{ expense | money: 'shortSignSimpleSpace' }}
              </span>
            </div>
          }
        </div>
      </div>
    </div>
  </app-dynamic-projected-table>
</div>
